export default "/Schulungs-PDF.pdf"